import 'Styles/common.less';

import 'Components/main-content/main-content.less';
import 'Components/breadcrumbs/breadcrumbs.less';
import 'Components/structure-list/structure-list.less';

import 'WebComponents/greedy-nav';
import { A11y } from 'WebComponents/a11y';

const a11y = new A11y();
a11y.init();



// WEBPACK FOOTER //
// ./src/pages/units-list/index.js